// 电池管理
import http from "@/jslibs/axios/http";

// 新增电池
export const add = (data) => http.post("/cms/battery/add", data);

// 编辑电池
export const edit = (data) => http.post("/cms/battery/update", data);

// 电池状态批量修改
export const updateStatus = (data) => http.post("/cms/battery/updateStatus", data);

// 电池详情
export const detail = (id) => http.get("/cms/battery/details/" + id);

// 电池全量列表
export const list = (data) => http.get("/cms/battery/list", data);

// 电池分页列表
export const page = (data) => http.get("/cms/battery/page", data);

// 电池删除
export const del = (id) => http.delete("/cms/battery/" + id);

// 电池导入模板
export const excelStencil = () => http.post("/cms/battery/excelStencil", {}, { responseType: "blob" });

// 电池导出
export const excel = (data) => http.post("/cms/battery/excel", data, { responseType: "blob" });

// 电池导入
export const importExcel = ({ file }) => {
    const params = new FormData();
    params.append("file", file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post("/cms/battery/importExcel", params, config);
};